<template>
  <div>
    <ValidationObserver ref="observer">
      <b-row class="mt-1">
        <b-col v-if="!isLightMode">
          <c-tel-input v-model="authentication.phone" />
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <ValidationProvider
            rules="required|email|"
            v-slot="{ errors }"
            name="email"
            v-if="!setvalues"
          >
            <c-input
              inputType="text"
              :inputId="`email`"
              labelText="Email *"
              v-model="authentication.email"
            />
            <span class="validate-error validate-error-red">{{
              errors[0]
            }}</span>
          </ValidationProvider>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            name="User Name"
          >
            <c-input
              inputType="text"
              :inputId="`username`"
              labelText="User Name *"
              v-model="authentication.userName"
            />
            <span class="validate-error validate-error-red">{{
              errors[0]
            }}</span>
          </ValidationProvider>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            name="password"
          >
            <div class="password-input-wrapper">
              <c-input
                :inputType="passwordInputType"
                :inputId="`pwd`"
                labelText="Password *"
                v-model="authentication.password"
                autocomplete="new-password"
              />
              <img
                :src="
                  passwordInputType === 'password'
                    ? require('@/assets/icon/passwordHideIcon.svg')
                    : require('@/assets/icon/passwordViewIcon.svg')
                "
                @click="togglePasswordVisibility"
                class="password-toggle-icon"
              />
            </div>
            <span class="validate-error validate-error-red">{{
              errors[0]
            }}</span>
          </ValidationProvider>
          <small
            id="passwordHelp"
            class="form-text text-muted mx-1 password-help-text"
            v-if="authentication.password"
          >
            <span
              v-if="!has_minimum_lenth"
              :class="has_minimum_lenth ? 'has_required' : ''"
              class="validate-error"
              >Password should contain atleast 8 characters ,</span
            >
            <span
              v-if="!has_number"
              :class="has_number ? 'has_required' : ''"
              class="validate-error"
            >
              alphanumeric ,
            </span>
            <span
              v-if="!has_uppercase"
              :class="has_uppercase ? 'has_required' : ''"
              class="validate-error"
            >
              first letter of the password should be capital and</span
            >
            <span
              v-if="!has_special"
              :class="has_special ? 'has_required' : ''"
              class="validate-error"
            >
              one special character (@, $, !, &, etc)</span
            >
          </small>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-if="!isLightMode">
          <eb-select
            :label="'text'"
            placeholder="Security Question *"
            :options="securityQuestions"
            v-model="authentication.securityQuestions.question"
          ></eb-select>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-if="!isLightMode">
          <c-input
            inputType="text"
            :inputId="`sqa`"
            labelText="Security Question Answers *"
            v-model="authentication.securityQuestions.answer"
          />
        </b-col>
      </b-row>
      <slot
        name="footer-button"
        :data="{ ...authentication, passwordValid }"
      ></slot>
    </ValidationObserver>
  </div>
</template>
<script>
import cInput from "@/components/Common/CustomInput";
import cTelInput from "@/components/Common/MobileNumberInput";
import ebSelect from "@/components/FormElements/Select";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  name: "Authentication",
  props: ["officeData", "isLightMode"],
  data() {
    return {
      has_minimum_lenth: false,
      has_number: false,
      has_uppercase: false,
      has_special: false,
      passwordInputType: "password",
      securityQuestions: [
        {
          text: "what is your mother maiden name",
          value: "what is your mother maiden name",
        },
        {
          text: "what is your first school",
          value: "what is your first school",
        },
        { text: "your first car model", value: "your first car model" },
      ],
      authentication: {
        phone: "",
        email: "",
        userName: "",
        password: "",
        securityQuestions: {
          question: {},
          answer: "",
        },
      },
    };
  },
  methods: {
    isValid() {
      const isValid = this.$refs.observer.validate();
      this.$emit("isValid", isValid);
      return isValid;
    },
    togglePasswordVisibility() {
      this.passwordInputType =
        this.passwordInputType === "password" ? "text" : "password";
    },
  },
  mounted() {
    if (this.isLightMode) {
      this.authentication.securityQuestions.question =
        this.securityQuestions[0];
      this.authentication.securityQuestions.answer = "NA";
    }
  },
  watch: {
    officeData: function (officeData) {
      if (this.isLightMode) {
        if (this.$route.query.partner === "true") {
          this.authentication.userName = officeData?.office?.officeName;
          this.authentication.phone = officeData?.office?.phone[0]?.number;
          this.authentication.email = officeData?.office?.email[0]?.mailId;
        } else {
          this.authentication.userName = officeData?.officeName;
          this.authentication.phone = officeData?.phone[0]?.number;
          this.authentication.email = officeData?.email[0]?.mailId;
        }
      }
    },
    "authentication.password"() {
      this.has_minimum_lenth = this.authentication?.password.length > 7;
      this.has_number = /\d/.test(this.authentication?.password);
      this.has_uppercase = /[A-Z]/.test(
        this.authentication?.password.split("")[0]
      );
      this.has_special = /[!@#\$%\^\&*\)\(+=._-]/.test(
        this.authentication?.password
      );
    },
  },
  computed: {
    passwordValid() {
      return (
        this.has_minimum_lenth &&
        this.has_number &&
        this.has_uppercase &&
        this.has_special
      );
    },
  },
  components: {
    cInput,
    cTelInput,
    ebSelect,
    ValidationProvider,
    ValidationObserver,
  },
};
</script>
<style scoped>
.password-toggle-icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}
[btn-color="primary"] {
  height: 41px;
  background-color: var(--primary);
  font-weight: 600;
  font-size: medium;
  letter-spacing: 2px;
  font-family: "Lato";
  color: white;
  border: 0px;
  border-radius: 0px;
}

[btn-special="primary"] {
  border: 0px;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: medium;
  font-family: "Lato";
  border-radius: 0px;
  height: 43px;
  width: 139px;
  background-color: var(--primary);
  color: white;
}
.sqanswer {
  margin-top: -12px !important;
}

.has_required {
  visibility: hidden;
  color: red;
}
.validate-error {
  color: red;
}

.validate-error-red {
  color: red;
}

.password-input-wrapper {
  position: relative;
}

.password-help-text {
  font-size: 13px;
}
</style>
